// src/utils/get-page-title.js

// 默认标题
const title = '焦化11种隐患人管理后台'

/**
 * 获取页面标题
 * @param {string} pageTitle - 页面标题
 * @returns {string} 完整的页面标题
 */
export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return title
} 